/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApiResponseDTOCurrentBusinessProfileDTO } from '../models/ApiResponseDTOCurrentBusinessProfileDTO';
import type { ApiResponseDTOListBusinessProfileSummaryDTO } from '../models/ApiResponseDTOListBusinessProfileSummaryDTO';
import type { SelectBusinessProfileRequestDTO } from '../models/SelectBusinessProfileRequestDTO';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class BusinessProfileControllerService {

    /**
     * Lists the business profiles this account can act as.
     *
     * @param authorization the signed-in user's access token
     *
     * /select-profile sits outside TokenHOC, so the interceptor that normally
     * installs `Authorization` is not mounted there and the token has to be
     * passed explicitly - otherwise the call answers 401 right after signing in.
     */
    public static profiles(
        authorization?: string,
    ): CancelablePromise<ApiResponseDTOListBusinessProfileSummaryDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/corporate/team/profiles',
            headers: authorization
                ? { Authorization: `Bearer ${authorization}` }
                : undefined,
            errors: {
                400: `Bad Request`,
                403: `Forbidden`,
                404: `Not Found`,
                422: `Unprocessable Entity`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns ApiResponseDTOCurrentBusinessProfileDTO OK
     * @throws ApiError
     */
    public static current(): CancelablePromise<ApiResponseDTOCurrentBusinessProfileDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/corporate/team/profiles/current',
            errors: {
                400: `Bad Request`,
                403: `Forbidden`,
                404: `Not Found`,
                422: `Unprocessable Entity`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody
     * @returns ApiResponseDTOCurrentBusinessProfileDTO OK
     * @throws ApiError
     */
    public static select(
        requestBody: SelectBusinessProfileRequestDTO,
        authorization?: string,
    ): CancelablePromise<ApiResponseDTOCurrentBusinessProfileDTO> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/corporate/team/profiles/current',
            headers: authorization
                ? { Authorization: `Bearer ${authorization}` }
                : undefined,
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                403: `Forbidden`,
                404: `Not Found`,
                422: `Unprocessable Entity`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
